import { Component, ElementRef, inject, ChangeDetectionStrategy } from '@angular/core';

import type { DialogComponentI } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-wysiwyg-full-screen-dialog',
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: ``,
})
export class FullScreenDialogComponent implements DialogComponentI<void, void> {
  private readonly elementRef = inject<ElementRef<Element>>(ElementRef);

  public get element() {
    return this.elementRef.nativeElement;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(data: void, triggerUpdate: boolean) {}
}
